export const colorOptions = [
  '#85BFCC',
  '#FFAEA4',
  '#4196D6',
  '#09D8D8',
  '#DE473A',
  '#89261D',
  '#262E72',
  '#07A7A7',
  '#74D17D',
  '#1A7C25',
  '#F36E41',
  '#914AE5',
  '#AF431E',
  '#56E242',
];

export const gaugeRangeColorOptions = [
  '#de473a',
  '#f24631',
  '#f36e41',
  '#ffff00',
  '#ffef00',
  '#f7ed61',
  '#32b740',
  '#70bc7c',
  '#74d17d',
];
